import { ChevronDownIcon, BookOpenIcon } from '@heroicons/react/24/outline';
import { Menu, createStyles, rem } from '@mantine/core';
import { useState } from 'react';

const useStyles = createStyles((theme) => ({
  dropdown: {
    border: 0,
    borderRadius: theme.radius.lg,
    boxShadow: theme.shadows.md,
    padding: `8px`,
  },

  item: {
    borderRadius: theme.radius.md,
    padding: `${theme.spacing.xs} ${theme.spacing.xs}`,
    color: 'rgba(0, 0, 0, 0.87)',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#29748F',
    },
    '&[data-hovered]': {
      backgroundColor: '#f5f5f5',
      color: '#29748F',
    },
  },

  label: {
    fontWeight: 500,
  },

  icon: {
    width: rem(20),
    height: rem(20),
  },

  control: {
    backgroundColor: '#dbeafe',
    color: '#29748F',
    borderRadius: theme.radius.md,
    padding: `8px 16px`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.xs,
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,
    border: '1px solid #eaeaea',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      opacity: '90%',
      // backgroundColor: "#6497b1",
      // borderColor: "#29748F",
    },
  },

  chevron: {
    transition: 'transform 200ms ease',
    '&[data-rotate]': {
      transform: 'rotate(180deg)',
    },
  },
}));

interface SubjectDropdownProps {
  subjects?: string[];
  activeSubject: string;
  onSubjectChange: (subject: string) => void;
  className?: string;
}

export const SubjectDropdown = ({
  subjects,
  activeSubject,
  onSubjectChange,
  className = '',
}: SubjectDropdownProps) => {
  const { classes, theme } = useStyles();
  const [opened, setOpened] = useState(false);

  // Ensure subjects is an array and has items
  const safeSubjects = Array.isArray(subjects) ? subjects : [];

  if (safeSubjects.length === 0) return null;

  return (
    <div className={className}>
      <Menu
        shadow='md'
        width={100}
        position='bottom'
        offset={10}
        radius='md'
        opened={opened}
        onChange={setOpened}
        classNames={{
          dropdown: classes.dropdown,
          label: classes.label,
        }}
      >
        <Menu.Target>
          <button className={classes.control}>
            {activeSubject}
            <ChevronDownIcon
              className={classes.chevron}
              style={{
                transform: opened ? 'rotate(180deg)' : 'none',
                transition: 'transform 200ms ease',
              }}
              width={16}
            />
          </button>
        </Menu.Target>

        <Menu.Dropdown className='p-2 bg-white rounded-2xl space-y-1'>
          {/* <Menu.Label>Select Subject</Menu.Label> */}
          {Array.isArray(subjects) &&
            subjects.map((subject) => (
              <Menu.Item
                key={subject}
                onClick={() => onSubjectChange(subject)}
                data-selected={subject === activeSubject || undefined}
                className={`mb-1 inline-flex items-center justify-center text-center w-full rounded-xl transition-colors focus:outline-none disabled:opacity-50 disabled:pointer-events-none h-10 !py-1 px-2 ${
                  subject === activeSubject
                    ? 'bg-blue-100 text-primary hover:bg-blue-200 font-semibold'
                    : 'bg-white hover:bg-blue-100/50 text-primary'
                }`}
              >
                {subject}
              </Menu.Item>
            ))}
        </Menu.Dropdown>
      </Menu>
    </div>
  );
};

export default SubjectDropdown;
